<template>
	<section class="vipRecharge">
		<header-com />
		<div class="toRechargeList f24" @click="toRechargeRecord">
			充值、消费记录 >
		</div>
		<div class="topWrap">
			<h5 class="f28">我的余额(元)</h5>
			<h2 class="bold">{{ customerInfo.balance }}<span>&nbsp;元</span></h2>
		</div>

		<div class="cardBox">
			<div v-if="vipList.length > 0" class="cardBoxSon1">
				<div class="cardType">会员充值</div>
				<div v-for="(item, index) in vipList" :key="index" class="vipCard">
					<div>
						<div class="title">{{ item.remark }}</div>
						<div class="price">¥{{ item.amount }}</div>
						<div class="word">{{item.description}}</div>
					</div>
					<div class="recharge" @click="showPopup(item)">立即充值</div>
				</div>
			</div>

			<div v-if="cardList.length > 0" class="cardBoxSon2">
				<div class="cardType">优惠特权卡</div>
				<div
					v-for="(item, index) in cardList"
					:key="index"
					class="discountCard"
				>
					<div>
						<div class="title">{{ item.name }}¥{{ item.amount }}</div>
						<div class="word">{{ item.remark }}</div>
						<div class="day">{{ item.discountCardDayTime }}天</div>
					</div>
					<div class="recharge" @click="showPopup(item)">立即购买</div>
				</div>
			</div>
		</div>

		<van-popup
			v-model="isShowPopup"
			position="bottom"
			:overlay="true"
			:lock-scroll="true"
		>
			<section class="popupInners">
				<div class="close_cont" @click="isShowPopup = false">
					<div class="close"></div>
				</div>

				<div v-if="payItem.type==10" class="msgBox">
					<div class="price">
						<div class="price48">充值金额¥{{payItem.amount}}</div>
						<div class="price48"></div>
					</div>
					<div class="priceLine"></div>
					<div class="price">
						<div class="price48">{{payItem.remark}}</div>
						<div class="price48"></div>
					</div>
				</div>

        <div v-if="payItem.type==20" class="msgBox">
					<div class="price">
						<div class="price32">金额</div>
						<div class="price48">¥{{payItem.amount}}</div>
					</div>
					<div class="priceLine"></div>
					<div class="price">
						<div class="price32">有效期</div>
						<div class="price48">{{payItem.discountCardDayTime}}天</div>
					</div>
				</div>

				<div class="wordBox">
					<div class="word">
						<span v-if="payItem.type==10">
							*充值{{payItem.amount}}元{{payItem.remark}}<br />
							<span v-if="payItem.description">*{{payItem.description}}<br /></span>
						</span>
            <span v-if="payItem.type==20">
              *优惠特权卡在有效期内可无限次使用<br />
						  *不可与优惠券同时使用<br />
							*优惠特权卡使用后将不可退款<br />
            </span>
						*如有疑问，请致电400-052-0618<br />
						*活动解释权归包拯所有<br />
            *赠送金额为促销权益，非实际支付款项，随会员服务同步生效，退回时不支持单独折算退回<br />
					</div>
				</div>

				<div class="pay-style">
					<li @click="payType = true">
						<img class="icon" src="/images/order/wechat.png" alt="" />
						<div class="name" :class="{ borderNone: isWeiXin }">
							微信支付
						</div>
						<div class="radio" v-if="!isWeiXin">
							<radio :checked="payType" />
						</div>
					</li>
					<li @click="payType = false" v-if="!isWeiXin">
						<img class="icon alipay" src="/images/order/alipay.png" alt="" />
						<div class="name">支付宝支付</div>
						<div class="radio"><radio :checked="!payType" /></div>
					</li>
				</div>

				<div class="payBox">
					<button class="primary myPay" @click="primaryAction" :disabled="paying">
						{{ payingText }}
					</button>
				</div>
			</section>
		</van-popup>
	</section>
</template>

<script>
import myApi from "@/axios/my";
import payObj from "@/assets/js/pay";
import loginApi from "@/axios/login";
import wxShare from "@/assets/js/wx.share";
import publicObj from "@/assets/js/public";
import zhugeObj from "@/assets/js/track";
export default {
	name: "vipRecharge",
	components: {},
	data() {
		return {
			payType: true,
			active: 0,
			isShowPopup: false,
			showItem: {
				parent: {},
				gift: {},
			},
			vipList: [],
			cardList: [],
			customerInfo: {},
			paying: false,
			payingText: "立即充值",
			isWeiXin: false,

      payItem: {}
		};
	},
	watch: {},
	computed: {},
	mounted() {
		this.isWeiXin = publicObj.isWeiXin();
		this.getBaseInfo();
		this.getVipList();
		this.getCardList();
		setTimeout(() => {
			this.setShare();
		}, 100);
	},
	methods: {
		setShare() {
			let _this = this;
			wxShare({
				title: "成为会员，每年可省至少1000元",
				desc: "充值立返金额，还有会员专享服务",
				link: location.href + "?source=share",
				imgUrl:
					"https://baozheng-front-new.oss-cn-beijing.aliyuncs.com/2019/05/27/227eb4a6-5f89-462e-bb79-c5c8db7a2cd8.jpeg",
			});
		},
		formatImgUrl(url, width, height, m_fill) {
			// console.log(url)
			if (url) {
				url = url.replace(
					"h_{height},w_{width}",
					"h_" + height + ",w_" + width + ""
				);
				// url = url.replace(',jpg', ",webp");
				url += ",q_80";
				if (m_fill) {
					// console.log(m_fill)
					url = url.replace("m_lfit", "m_fill");
				}
			}
			return url;
		},
		showName(showItem) {
			if (showItem.giftType == 20) {
				return showItem.parent.amount + "  +  " + showItem.name;
			} else {
				return showItem.name;
			}
		},
		getVipList() {
			myApi.getRecharge({ type: 10 }).then((res) => {
				this.vipList = res;
			});
		},
		getCardList() {
			myApi.getRecharge({ type: 20 }).then((res) => {
				let arr = []
				for(let i = res.length-1; i>=0; i--) {
					arr.push(res[i])
				}
				console.log('arr',arr)
				this.cardList = arr;
			});
		},
		getBaseInfo() {
			myApi.customerInfo().then((res) => {
				this.customerInfo = res;
			});
		},
		showPopup(item) {
			this.isShowPopup = true;
      this.payItem = item
		},
		
		toRechargeRecord() {
			zhugeObj.track({
				title: "用户充值",
				content: {
					"充值/消费记录": "查看充值消费记录",
				},
			});
			this.$router.push({ name: "rechargeRecord" });
		},
		readActh() {
			const code =
				this.$route.query.code || publicObj.GetQueryString("code") || "";
			if (code) {
				//  alert('有code');
				// alert('这是CODE'+code);
				loginApi
					.getAUthUrl({
						wxAuthorizeCode: code,
					})
					.then((res) => {
						localStorage.setItem("openId", res.openId);
						localStorage.setItem("unionId", res.unionId);
						this.confirm();
					});
			}
		},
		primaryAction() {
			let payParams = payObj.getPayParams(this.payType);

			const openId = localStorage.getItem("openId");
			// if(!openId){
			//   this.readActh()
			//   return
			// }
			let params = {
				rechargeRuleId: this.payItem.id,
				openId: openId,
				backUrl: "https://mi.baozheng.cc/my/rechargeRecord",
			};

			if (publicObj.isWeiXin()) {
				params.paymentPlatform = "WeChat";
			} else {
				if (this.payType) {
					params.paymentPlatform = "WeChat_h5";
				} else {
					params.paymentPlatform = "AliPay_h5";
				}
			}
			//支付参数
			this.paying = true;
			this.payingText = "充值中...";
			myApi
				.recharge(params)
				.then((res) => {
					if (params.paymentPlatform == "WeChat_h5") {
						window.location.href = res.paymentData.h5PayUrl;
						return;
					}
					if (params.paymentPlatform == "AliPay_h5") {
						window.location.href = res.paymentData.h5PayUrl;
						return;
					}
					zhugeObj.track({
						title: "用户充值",
						content: {
							充值结果: "成功",
							充值金额: this.showItem.parent.name,
							赠品: this.showItem.name,
						},
					});

					payObj.confirmPay(payParams.payChannel, res.paymentData, 2);
				})
				.catch(() => {
					zhugeObj.track({
						title: "用户充值",
						content: {
							充值结果: "失败",
							充值金额: this.showItem.parent.name,
							赠品: this.showItem.name,
						},
					});
					this.paying = false;
					this.payingText = "立即充值";
				});
		},
		payConfirm() {
			this.$dialog.alert({
      	message: '充值金额仅支持可与赠送3张抵扣券同享'
    	}).then(() => {
				this.primaryAction()
			})
		}
	},
};
</script>
<style>
[class*="van-hairline"]::after {
	border-top: none;
}
</style>

<style lang="scss" scoped>
.pay-style {
  width: 100%;
	padding: 40px 30px 0;
  box-sizing: border-box;
	li {
		display: flex;
		align-items: center;
		margin-bottom: 40px;
		position: relative;
		.icon {
			width: 52px;
			height: 48px;
			object-fit: cover;
			margin-right: 16px;
			flex: none;
		}
		.name {
			flex: none;
			font-size: 28px;
			color: #333333;
			line-height: 52px;
		}
		.radio {
			position: absolute;
			top: 5px;
			right: 0;
			flex: none;
		}
	}
}
.content {
	margin-top: 80px;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	padding: 40px;
	min-height: 700px;
	padding-top: 100px;
}
.vipRecharge {
	// padding: 128px 0 0;
	.toRechargeList {
		position: absolute;
		right: 0px;
		top: 166px;
		padding: 12px 18px 14px;
		line-height: 34px;
		border-radius: 8px 0 0 8px;
		background-color: white;
		z-index: 101;
		img {
			width: 30px;
			height: 30px;
			text-align: right;
		}
	}
	.topWrap {
		width: 100%;
		box-sizing: border-box;
		padding: 110px 40px 66px;
		height: 364px;
		background: url("/images/my/topWrap.png") no-repeat;
		background-size: cover;
		color: white;
		h5 {
			line-height: 34px;
			margin-bottom: 20px;
		}
		h2 {
			letter-spacing: -1px;
			font-size: 68px;
			span {
				font-size: 32px;
			}
		}
	}

	.cardBox {
		width: 100%;
		box-sizing: border-box;
		padding: 48px 30px;
		margin-top: -100px;
		border-radius: 32px 32px 0 0;
		background-color: white;
		.cardBoxSon1 {
			margin-bottom: 30px;
			.cardType {
				font-size: 32px;
				line-height: 40px;
				font-weight: 500;
				margin-bottom: 18px;
			}
			.vipCard {
				width: 690px;
				height: 196px;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;
				flex-wrap: nowrap;
				margin-bottom: 24px;
				&:nth-child(4n + 2) {
					background: url("/images/my/vipCard1.png") no-repeat;
					background-size: cover;
				}
				&:nth-child(4n + 3) {
					background: url("/images/my/vipCard2.png") no-repeat;
					background-size: cover;
				}
				&:nth-child(4n + 4) {
					background: url("/images/my/vipCard3.png") no-repeat;
					background-size: cover;
				}
				&:nth-child(4n + 5) {
					background: url("/images/my/vipCard4.png") no-repeat;
					background-size: cover;
				}
				.title {
					height: 50px;
					padding: 0 20px;
					line-height: 50px;
					font-size: 24px;
					color: white;
					background: url("/images/my/vipCard_title.png") no-repeat;
					background-size: cover;
				}
				.price {
					margin-top: 30px;
					font-size: 48px;
					margin-left: 20px;
				}
				.word {
					font-size: 24px;
					margin-top: 20px;
					margin-left: 20px;
					color: #aaaaaa;
				}
				.recharge {
					margin-right: 20px;
					width: 194px;
					height: 66px;
					font-size: 32px;
					color: white;
					line-height: 66px;
					text-align: center;
					border-radius: 33px;
					background-color: #333333;
					margin-top: 66px;
				}
			}
		}
		.cardBoxSon2 {
			margin-bottom: 30px;
			.cardType {
				font-size: 32px;
				line-height: 40px;
				font-weight: 500;
				margin-bottom: 18px;
			}
			.discountCard {
				width: 690px;
				height: 260px;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;
				flex-wrap: nowrap;
				margin-bottom: 24px;
				padding: 30px 20px;
				box-sizing: border-box;
				&:nth-child(3n + 2) {
					background: url("/images/my/discountCard1.png") no-repeat;
					background-size: cover;
				}
				&:nth-child(3n + 3) {
					background: url("/images/my/discountCard2.png") no-repeat;
					background-size: cover;
				}
				&:nth-child(3n + 4) {
					background: url("/images/my/discountCard3.png") no-repeat;
					background-size: cover;
				}
				.title {
					line-height: 56px;
					font-size: 40px;
					color: #f0dbd4;
				}
				.word {
					margin-top: 10px;
					font-size: 24px;
					color: #f0dbd4;
				}
				.day {
					margin-top: 50px;
					font-size: 40px;
					color: white;
				}
				.recharge {
					width: 194px;
					height: 66px;
					font-size: 32px;
					color: #333333;
					line-height: 66px;
					text-align: center;
					border-radius: 33px;
					background-color: #f0dbd4;
					margin-top: 134px;
				}
			}
		}
	}

	/*弹窗*/
	.van-popup {
		background: transparent;
	}
	.popupInner {
		height: 818px;
		padding-top: 184px;
		position: relative;
		.picWrap {
			width: 560px;
			height: 490px;
			position: absolute;
			left: 95px;
			top: 0;
			background: url("/images/my/vipRecharge_01.png") no-repeat left top;
			background-size: 100%;
			.pic {
				width: 320px;
				height: 210px;
				position: absolute;
				left: 50%;
				top: 80px;
				transform: translateX(-50%);
			}
			.icon {
				width: 104px;
				position: absolute;
				right: 8px;
				top: 58px;
			}
			.title {
				width: 480px;
				position: absolute;
				left: 40px;
				top: 378px;
				height: 72px;
				line-height: 36px;
				color: $white-color;
			}
		}
		.content {
			background: $white-color;
			height: 492px;
			padding: 326px 20px 0;

			.close {
				position: absolute;
				right: 40px;
				top: 218px;
			}
			.priceWrap {
				width: 520px;
				margin: 0 auto 80px;
				display: flex;
				justify-content: space-around;
				padding-bottom: 2px;
				height: 74px;
				line-height: 74px;
				font-size: 52px;
				border-bottom: 4px $primary-color solid;
			}
			ul {
				line-height: 34px;
				color: #9b9b9b;
				padding: 0 16px 30px;
				li {
					margin-bottom: 12px;
					list-style: disc inside;
				}
			}
		}
	}
}
.popupInners {
	background: #fff;
	border-radius: 32px 32px 0 0;
  width: 100%;
  box-sizing: border-box;
	padding-bottom: 30px;
	padding-bottom: env(safe-area-inset-bottom);
	.close_cont {
		width: 100%;
		height: 80px;
		box-sizing: border-box;
		padding-top: 40px;
		.close {
			width: 182px;
			height: 20px;
			border-radius: 10px;
			background: #f0f0f0;
			margin: 0 auto;
		}
	}

	.msgBox {
		width: 100%;
		box-sizing: border-box;
		padding: 0px 60px 0;
		.price {
			display: flex;
			padding-bottom: 36px;
			padding: 48px 0px 36px;
			justify-content: space-between;
			.price32 {
				font-size: 32px;
			}
			.price48 {
				font-size: 48px;
			}
		}
		.priceLine {
			height: 1px;
			background: #979797;
		}
	}
	.wordBox {
		width: 100%;
		box-sizing: border-box;
		padding: 0px 30px 30px;
		.word {
			width: 100%;
			box-sizing: border-box;
			padding: 30px;
			border-radius: 12px;
			background-color: #f6f6f6;
			font-size: 24px;
			color: #686868;
			line-height: 40px;
		}
	}
}
.payBox {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  .myPay{
    width: 100%;
  }
}
</style>
